import { ScheduledEvent } from '@shared/types';

export type EventsState = {
  events: Array<ScheduledEvent>
  current?: ScheduledEvent;
  error?: string;
  isBusy: boolean;
}

export const events: EventsState = {
  events: [],
  current: undefined,
  isBusy: false,
  error: undefined
};
